import HttpHelper from '@/helpers/http';

interface IRTMPSettings {
  streamKey: string;
  RTMPAddress: string;
}

export default class RTMPApi {
  static async getSettings(): Promise<IRTMPSettings> {
    return await HttpHelper.get('/api/v1/rtmp/settings', { background: true });
  }
}
